import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import { userSelector } from "../../store/selectors";
import ProfileSidebar from "../../components/ProfileSidebar/ProfileSidebar";
import emailjs from "@emailjs/browser";
import "./AcceptDocumentScreen.css";
import ProfileMainIcon from "../../assets/profile-main.svg";
import TextField from "@mui/material/TextField";

import ProfileBillingIcon from "../../assets/profile-billing.svg";
import ProfileNotificationsIcon from "../../assets/profile-notifications.svg";
import ProfileSecurityIcon from "../../assets/profile-security.svg";
import ProfileTeamIcon from "../../assets/users.svg";
import ProfileActiveSessionsIcon from "../../assets/profile-active-sessions.svg";
import Avatar from "../../components/Avatar/Avatar";
import AppLogo from "../../assets/AppLogoBlue.svg";
import toast from "react-hot-toast";
import {
  acceptNeededAgreement,
  deleteAgreement,
  fetchAgreements,
  fetchNeededAgreements,
} from "../../store/usersSlice";

import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import NotificationsPopup from "../../components/NotificationsPopup/NotificationsPopup";
import ProfilePopup from "../../components/ProfilePopup/ProfilePopup";
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import InfoModal from "../../components/InfoModal/InfoModal";
import { ReactComponent as MenuIcon } from "../../assets/mobile/menu.svg";
import useIsMobile from "../../hooks/useIsMobile";
import AddAgreementModal from "../../components/AddAgreementModal/AddAgreementModal";

const AcceptDocumentScreen = () => {
  const user = useSelector(userSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [documentsArray, setDocumentsArray] = useState([]);

  const handleAcceptAllAgreements = async () => {
    for (let i = 0; i < documentsArray.length; i++) {
      await dispatch(
        acceptNeededAgreement(documentsArray[i].currentVersion.id)
      );
    }

    localStorage.removeItem("redirectUrl");
    navigate("/home");
  };

  useEffect(() => {
    dispatch(fetchNeededAgreements()).then((res) => {
      if (!res.error) {
        const needAcceptance = res.payload.filter(
          (agreement) => !agreement.accepted
        );
        setDocumentsArray(needAcceptance);
      }
    });
  }, []);

  if (!user) return null;

  return (
    <div className={isMobile ? "App-mobile" : "App"}>
      <div
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 2,
          // padding: "20px 19px",
        }}
      >
        <div
          style={{
            flex: 1,
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            // marginRight: 33,
          }}
        >
          <div
            style={{
              width: 600,
              // height: "85%",
              backgroundColor: "#1F242E",
              borderRadius: 50,
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
              boxSizing: "border-box",
              padding: 48,
              paddingTop: 24,
              paddingBottom: 32,
            }}
          >
            <span className="accept-agreement-title">
              Условия пользования сервисом
            </span>
            <span className="accept-agreement-subtitle">
              Чтобы продолжить пользоваться сервисом, ознакомьтесь со следующими
              документами и подтвердите свое согласие:
            </span>
            {documentsArray.map((document, index) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  width: "100%",
                }}
              >
                <span
                  onClick={() => {
                    window.open(document.currentVersion.pdfUrl, "_blank");
                  }}
                  className="accept-agreement-link"
                >{`${index + 1}. ${document.name}`}</span>
              </div>
            ))}
            <PrimaryButton
              text={"Принять и продолжить"}
              onClick={() => handleAcceptAllAgreements()}
              style={{
                marginLeft: "8px",
                marginTop: 0,
                fontSize: 14,
                padding: "12px 24px",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcceptDocumentScreen;
